import type { Directive } from 'vue'
import iframeResize from 'iframe-resizer/js/iframeResizer'
import { defineNuxtPlugin } from '#app'

const vResizeDirective: Directive<HTMLElement> = {
  beforeMount(el, { value = {} }) {
    el.addEventListener('load', () => iframeResize(value, el))
  },
  unmounted(el) {
    el.iFrameResizer.removeListeners()
  },
}

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.directive('resize', vResizeDirective)
})
